module.exports = "https://trybtryb-legacy.web.app/img/check-mark.78e38715.svg";